// REACT IMPORTS
import React from "react";

// COMPONENT IMPORTS
import SidePanel from "components/auth/SidePanel";
import QuestionsFooter from "components/auth/QuestionsFooter";
import ResetPasswordForm from "components/auth/ResetPasswordForm";
import Helment from "components/layout/helmet";
import { TestIdScope } from "utils/testid";

/* ------------------------------------- OTP VERIFICATION ------------------------------------- */

const ResetPassword = () => {
  return (
    <>
      <Helment />
      <TestIdScope scope="auth-reset-password">
        <div
          data-testid="auth-reset-password-page"
          className="lg:overflow-y-none overflow-y-auto portal-shell h-[var(--shell-vh)] flex lg:justify-center relative animate__animated animate__fadeIn lg:flex-row flex-col"
        >
          <div className="lg:w-2/5 w-full">
            <SidePanel />
          </div>
          <div className="lg:w-3/5 w-full flex flex-col items-center justify-between lg:overflow-y-auto">
            <div className="lg:pt-[134px] p-5 w-full flex justify-center">
              <ResetPasswordForm />
            </div>
            <div className="pt-10 pb-[10px] lg:pt-[150px] lg:pb-5  lg:w-3/5 lg:pl-[90px]">
              <QuestionsFooter />
            </div>
          </div>
        </div>
      </TestIdScope>
    </>
  );
};

export default ResetPassword;
